import { FC } from 'react'

import { typography } from '@joor/design-system'
import styled from 'styled-components'

import { Contact } from 'features/Orders/components/Contacts/Contact'

const StyledContact = styled(Contact)`
  > div:nth-child(2) > span {
    cursor: pointer;
    ${typography.alpha.link.body2}
  }
`

type Props = {
  onClick?: () => void
}

export const AssignBuyerButton: FC<Props> = ({ onClick }) => (
  <StyledContact onClickName={onClick} name="Assign buyer" />
)
